import { api } from "@shared/lib/api";
import { BriefNotificationActionType } from "@shared/lib/types/brief";
import {
  IAssignPricingPocRequest,
  IBriefPricingFacets,
  IBriefPricingResponse,
  IBulkReachoutRequest,
  IPricingPOCResponse,
  IPricingWorkload,
  IReAllocatePricingPocRequest,
  IRemovePricingPocRequest,
} from "@shared/lib/types/pricingWorkload";
import { BackednResponse } from "@shared/lib/types/response";

export class PricingWorkloadService {
  public static async getPricingWorkloads({ userIds }: { userIds?: string[] }) {
    const url = "brief/influencer-v2/pricing/workload";
    const params = new URLSearchParams();
    if (userIds) {
      params.append("userIds", userIds.join("$$"));
    }
    return (await api
      .get(`${url}?${params.toString()}`)
      .json()) as BackednResponse<IPricingWorkload[]>;
  }

  public static async assignPricingPoc(data: IAssignPricingPocRequest) {
    const url = "brief/influencer-v2/pricing/assign-pricing-poc";
    return (await api.put(url, { json: data }).json()) as BackednResponse<
      IPricingPOCResponse[]
    >;
  }
  public static async removePricingPoc(data: IRemovePricingPocRequest) {
    const url = "brief/influencer-v2/pricing/remove-pricing-poc";
    return (await api.post(url, { json: data }).json()) as BackednResponse<
      IPricingPOCResponse[]
    >;
  }
  public static async reAllocatePricingPoc(data: IReAllocatePricingPocRequest) {
    const url = "brief/influencer-v2/pricing/reallocate-pricing-poc";
    return (await api.post(url, { json: data }).json()) as BackednResponse<
      IPricingPOCResponse[]
    >;
  }

  public static async getBriefPricing(briefId: string) {
    return (await api
      .get(`brief/influencer-v2/pricing/facets?briefId=${briefId}`)
      .json()) as BackednResponse<IBriefPricingResponse>;
  }

  public static async getPricingPocFacets(briefId: string, pocId: string) {
    return (await api
      .get(
        `brief/influencer-v2/pricing/facets/poc?briefId=${briefId}&assignedToPricingPocV2UserId=${pocId}`
      )
      .json()) as BackednResponse<IBriefPricingFacets>;
  }

  public static async editPricingNotes(payload: {
    briefInfluencerId: string;
    notes: string;
  }) {
    const url = "brief/influencer-v2/pricing/notes";
    return (await api
      .post(url, { json: payload })
      .json()) as BackednResponse<{}>;
  }

  public static async bulkReachout(payload: IBulkReachoutRequest) {
    const url = "brief/bulk-action/brief-influencer";
    return (await api
      .post(url, {
        json: {
          ...payload,
          actionType: payload.isResend
            ? BriefNotificationActionType.priceReachoutResend
            : BriefNotificationActionType.priceReachout,
          filterParams: {
            ...payload.filterParams,
            assignedPricingPocV2: payload.filterParams?.assignedPricingPocV2
              ? {
                  userIds: payload.filterParams?.assignedPricingPocV2,
                }
              : undefined,
          },
          isSelectAll: payload.isSelectAll,
          actionParams: payload.actionParams,
          ids: payload.ids,
          notIncludeIds: payload.notIncludeIds,
        },
      })
      .json()) as BackednResponse<{}>;
  }

  public static async reSendbulkReachout(payload: IBulkReachoutRequest) {
    const url = "brief/bulk-action/brief-influencer";
    return (await api
      .post(url, {
        json: {
          ...payload,
          actionType: "priceReachoutResend",
          filterParams: {
            briefId: payload.briefId,
          },
          isSelectAll: payload.isSelectAll,
          actionParams: payload.actionParams,
          ids: payload.ids,
          notIncludeIds: payload.notIncludeIds,
        },
      })
      .json()) as BackednResponse<{}>;
  }
}
